const CAPS = ["Multi-Tenant", "White Label", "Multi-Country", "Multi-Currency", "Custom Domains", "SEO Ready", "API Ready", "Role-Based Access"];

export default function CapabilityBar() {
  return (
    <div className="border-y border-sand bg-parch py-5" data-testid="capability-bar">
      <div className="container-x flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
        {CAPS.map((c, i) => (
          <span key={c} className="flex items-center gap-6 font-mono text-[11px] font-semibold uppercase tracking-[0.18em] text-stone2">
            {c}
            {i < CAPS.length - 1 && <span className="hidden text-terra sm:inline">✳</span>}
          </span>
        ))}
      </div>
    </div>
  );
}
